import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { AiMatch } from './components/AiMatch';
import { WatchTracker } from './components/WatchTracker';
import { NewThisSeason } from './components/NewThisSeason';
export function App() {
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-rose-500/30" data-id="element-0">
      <Nav data-id="element-1" />

      <main className="max-w-[1600px] mx-auto px-6 py-4 grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-12 lg:gap-20" data-id="element-2">
        <div className="flex flex-col min-w-0" data-id="element-3">
          <Hero data-id="element-4" />
          <AiMatch data-id="element-5" />
          <NewThisSeason data-id="element-6" />
        </div>

        <aside className="relative hidden lg:block" data-id="element-7">
          <div className="sticky top-24 pt-12" data-id="element-8">
            <WatchTracker data-id="element-9" />
          </div>
        </aside>

        {/* Mobile Watch Tracker - shows below main content on small screens */}
        <aside className="lg:hidden border-t border-white/5 pt-8 pb-12" data-id="element-10">
          <WatchTracker data-id="element-11" />
        </aside>
      </main>
    </div>;
}